import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { postLogin, putUpdate } from "../../api/auth.service";

export const fetchUpdateUser = createAsyncThunk(
  "user/fetchUpdateUser",
  async (data) => {
    await putUpdate(data);
    return data;
  }
);

export const fetchLoginUser = createAsyncThunk("user/fetchLoginUser", async (data, { rejectWithValue }) => {
  const userRaw = localStorage.getItem("user");

  let user = null;
  if (userRaw) {
    user = JSON.parse(userRaw);
  } else if (data) {
    const resp = await postLogin(data);
    if (resp?.response) {
      return rejectWithValue(resp?.response?.data?.message || resp?.response?.status || "loginError");
    }
    if (resp?.data?.role === "USER") {
      window.open("/", "_self");
      return { user: null };
    }
    user = resp.data;
  }
  return { user };
});

const fetchLoginUserReducer = {
  [fetchLoginUser.pending]: (state, action) => {
    state.isLoadingLogin = true;
    state.error = null;
  },
  [fetchLoginUser.fulfilled]: (state, action) => {
    const userData = action.payload.user;
    if (userData) {
      localStorage.setItem("user", JSON.stringify(userData));
      axios.defaults.headers.common = {
        Authorization: `bearer ${userData.token}`,
      };
      state.value = userData;
    }
    state.error = null;
    state.isLoadingLogin = false;
  },
  [fetchLoginUser.rejected]: (state, action) => {
    state.isLoadingLogin = false;
    state.error = action.payload;
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState: {
    value: null,
    error: null,
    isLoadingLogin: true, // true until we've checked localStorage
  },
  reducers: {
    logOut: (state, action) => {
      state.value = null;
      localStorage.clear();
      window.open('/', "_self")
    },
  },
  extraReducers: {
    ...fetchLoginUserReducer,
    [fetchUpdateUser.fulfilled]: (state, action) => {
      if (state.value && action.payload) {
        const updated = { ...state.value, ...action.payload };
        state.value = updated;
        localStorage.setItem("user", JSON.stringify(updated));
      }
    },
  },
});

export const { logOut } = userSlice.actions;

export default userSlice.reducer;
